/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ household: NonNullable<unknown> }} Invite_TitleInputs */

const en_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Join ${i?.household}`)
};

const de_invite_title = /** @type {(inputs: Invite_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.household} beitreten`)
};

/**
* | output |
* | --- |
* | "Join {household}" |
*
* @param {Invite_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const invite_title = /** @type {((inputs: Invite_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_invite_title(inputs)
	return en_invite_title(inputs)
});